import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { phrasesSelectorSavePhrases } from '../../actions/phrases-selector';
import { Omit, TDispatchProps, TStateProps } from '../../typings/utils';
import {
    OwnProps as PhrasesSelectorInspectorContainerProps,
    PhrasesSelectorModalContainer
} from '../PhrasesSelectorModalContainer/PhrasesSelectorModalContainer';

export type OwnProps = Omit<PhrasesSelectorInspectorContainerProps, 'onSubmit'>;

export type StateProps = TStateProps<PhrasesSelectorInspectorContainerProps, OwnProps>;

export type DispatchProps = TDispatchProps<PhrasesSelectorInspectorContainerProps, OwnProps>;

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    return {
        onSubmit() {
            dispatch(phrasesSelectorSavePhrases(ownProps.wizardId));
        }
    };
};

export const PhrasesSelectorGridContainer = connect<StateProps, DispatchProps, OwnProps>(
    null,
    mapDispatchToProps
)(PhrasesSelectorModalContainer);
